import React from 'react';
import { getPropertyPackagesStatus, translate } from '../../../../utils/Common';
import { FaFilter } from 'react-icons/fa';
import styles from './StatusSummaryCards.module.css';

const StatusSummaryCards = ({ 
    packagesDefault = [],
    statusCounts = {},
    statusPkgSelected = [], 
    onStatusClick,
    onMoreStatusClick
}) => {
    // Estatus base a mostrar: 1 (New), 2 (Reserved Door), 3 (In Locker)
    const baseViewStatus = [1, 2, 3];

    // Incluir dinámicamente otros estatus que:
    // - estén en statusCounts (por ejemplo, 6 = Anulled) o
    // - estén en statusPkgSelected (filtros activos)
    const dynamicStatusFromCounts = Object.keys(statusCounts || {})
        .map((key) => parseInt(key, 10))
        .filter((id) => !Number.isNaN(id) && !baseViewStatus.includes(id));

    const dynamicStatusFromSelection = (statusPkgSelected || [])
        .filter((id) => !baseViewStatus.includes(id));

    // Unimos y quitamos duplicados para obtener todos los estatus a mostrar en los badges
    const viewStatus = Array.from(
        new Set([...baseViewStatus, ...dynamicStatusFromCounts, ...dynamicStatusFromSelection])
    );

    const packageCounts = viewStatus.map((statusId) => {
        const hasStatusCounts = statusCounts && Object.keys(statusCounts).length > 0;
        // Si el backend envía statusCounts, usamos esos valores y
        // cualquier estatus que no venga en el objeto se muestra en 0.
        // Solo usamos packagesDefault como fallback cuando no hay statusCounts.
        const count = hasStatusCounts
            ? (statusCounts[statusId] || 0)
            : packagesDefault.filter(pkg => pkg.IdEstatus === statusId).length;

        const statusInfo = getPropertyPackagesStatus(statusId);
        return { 
            id: statusId, 
            count, 
            ...statusInfo 
        };
    });

    const handleBadgeClick = (statusId) => {
        if (onStatusClick) {
            onStatusClick(statusId);
        }
    };

    // Función para convertir hex a rgba con opacidad
    const hexToRgba = (hex, alpha = 0.1) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    // Determinar si un estado está activo
    const isStatusActive = (statusId) => {
        return statusPkgSelected.includes(statusId);
    };

    return (
        <div className={styles.badgesContainer}>
            {packageCounts.map((status) => {
                const isActive = isStatusActive(status.id);
                const textColor = status.color || '#6b7280';
                const bgColor = status.color ? hexToRgba(status.color, 0.1) : 'rgba(107, 114, 128, 0.1)';
                
                return (
                    <button
                        key={status.id}
                        type="button"
                        className={`${styles.badge} ${isActive ? styles.active : ''}`}
                        onClick={() => handleBadgeClick(status.id)}
                        style={{
                            backgroundColor: bgColor,
                            color: textColor,
                            // borderColor se controla vía CSS (.badge.active usa currentColor)
                        }}
                    >
                        <span className={styles.badgeIcon}>{status.icon}</span>
                        <span className={styles.badgeText}>
                            {status.count > 0 ? `${status.count} ${status.text}` : status.text}
                        </span>
                    </button>
                );
            })}

            <button
                type="button"
                className={styles.moreStatusButton}
                onClick={onMoreStatusClick}
            >
                <span className={styles.badgeIcon}>
                    <FaFilter size={14} />
                </span>
                <span className={styles.badgeText}>
                    {translate('dashboard.packages.search.moreStatus') || 'More status'}
                </span>
            </button>
        </div>
    );
};

export default StatusSummaryCards;
